import axios from "axios";
import { track } from "@/lib/ebook";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const REF_KEY = "cc_ref_code";

/**
 * Read & persist a ?ref=CODE param from the URL on any page load.
 * Returns the active referral code (from URL or localStorage), uppercased.
 */
export function captureRefCode() {
  if (typeof window === "undefined") return "";
  let code = "";
  try {
    const params = new URLSearchParams(window.location.search);
    const fromUrl = (params.get("ref") || "").trim().toUpperCase();
    if (fromUrl) {
      code = fromUrl;
      window.localStorage.setItem(REF_KEY, code);
      // Fire click tracking once per session, fire-and-forget
      track("referral_click", code);
      axios.post(`${API}/referrals/click/${code}`).catch(() => {});
    } else {
      code = (window.localStorage.getItem(REF_KEY) || "").toUpperCase();
    }
  } catch (_) {}
  return code;
}

export function getRefCode() {
  try {
    return (window.localStorage.getItem(REF_KEY) || "").toUpperCase();
  } catch (_) {
    return "";
  }
}

export function clearRefCode() {
  try { window.localStorage.removeItem(REF_KEY); } catch (_) {}
}

export async function joinReferralProgram(name, email) {
  const { data } = await axios.post(`${API}/referrals/join`, { name, email });
  return data;
}

export async function lookupReferralCode(code) {
  const { data } = await axios.get(`${API}/referrals/code/${code.toUpperCase()}`);
  return data;
}

export function buildShareUrl(code) {
  if (typeof window === "undefined") return "";
  return `${window.location.origin}/?ref=${encodeURIComponent(code)}`;
}
